import { Button } from "antd";
import React, { useCallback } from 'react';
import { useDispatch } from "react-redux";
import { loginActions } from "../../../../pages/LoginPage/reducer";
import { VesselSideService } from "../../../../util/services/vessel-side";
import { showErrorResponse } from "../../../../util/varibles/global";
import { IOperation2, ITreatment2 } from "../../../../util/varibles/interface";
import styles from './style.module.scss';

interface IProps {
    data: IOperation2<ITreatment2>
    isChange: boolean
    orderUnit: string[]

    onCancel(): void

    onUpdate?(args: any): void
}

const OrderControl: React.FC<IProps> = (props) => {
    const {
        data,
        isChange,
        orderUnit,
        onCancel,
        onUpdate,
    } = props;

    const dispatch = useDispatch();

    const handleSave = useCallback(() => {
        const { id, tenant_id = '', sub_operations } = data.operation;
        const params = {
            operation_id: id,
            tenant_id,
            unit_order: orderUnit.map((unit_id: string) => {
                const unit = sub_operations.find(item => item.unit_id === unit_id) || { id: '' };
                return { id: unit.id, unit_id }
            })
        };

        dispatch(loginActions.updateLoadingVesselSide(true));
        VesselSideService.orderUnits(params)
            .then((rs: any) => {
                const { activity_log, operation } = rs;
                dispatch(loginActions.updateLoadingVesselSide(false));
                const value = {
                    ...data,
                    activity_log,
                    operation: { ...data.operation, ...operation }
                };
                dispatch(loginActions.updateOpOfVessel(value as IOperation2));
                if (onUpdate)
                    onUpdate(value);
            })
            .catch(error => {
                dispatch(loginActions.updateLoadingVesselSide(false));
                showErrorResponse('Unit order change failed', error)
            })
    }, [data, orderUnit, onUpdate, dispatch])

    if (!isChange)
        return null;

    return <>
        <div className={styles.orderControl}>
            <Button className={styles.btCancel} onClick={onCancel}>
                Cancel
            </Button>
            <Button className={styles.btAdd} onClick={handleSave}>
                Save
            </Button>
        </div>
    </>;
};

export default OrderControl;
